// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var messageCache = {};
export function warnOnce(component, message) {
    var warning = "[".concat(component, "] ").concat(message);
    if (!messageCache[warning]) {
        messageCache[warning] = true;
        console.warn(warning);
    }
}
